import { TableCell, TableRow } from "@mui/material";
import { getArrayIsNotEmpty } from "../../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { getStateLabel } from "../../../utils/helpers/getStateLabel";
import { getExpiresIn } from "../../../utils/helpers/getExpiresIn";
import ArrowNextTableIcon from "../../../assets/icons/svg/ArrowNextTableIconSVG";

const defaultTextStyle = {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "black",
};

const AllOffersTableRow = ({ carOffers, onSelect }) => {
    const GetImageComponent = () => {
        let imgSource = "";
        const offersHaveImages = getArrayIsNotEmpty(
            carOffers.PartRequest?.PartRequestImages
        );

        if (offersHaveImages) {
            imgSource = carOffers.PartRequest.PartRequestImages[0].small_part_offers_image_url;
        }

        const ImageComponent = (
            <div style={styles.imageContainer}>
                <img src={imgSource} alt="Part" style={styles.imageStyle} />
            </div>
        );

        return imgSource ? (
            ImageComponent
        ) : (
            <div style={{ ...styles.imageContainer, backgroundColor: "#eee" }} />
        );
    };

    const stateLabel = getStateLabel(carOffers?.status);
    const { text: expiresInText, hoursLeft } = getExpiresIn(carOffers?.createdAt);

    return (
        <TableRow hover onClick={onSelect} sx={{ cursor: "pointer" }}>
            <TableCell>{GetImageComponent()}</TableCell>
            <TableCell sx={styles.textStyle}>
                {carOffers.description || "Nema opisa"}
            </TableCell>
            <TableCell sx={defaultTextStyle}>
                <div style={styles.getStateBadgeStyle(stateLabel)}>{stateLabel}</div>
            </TableCell>
            <TableCell sx={styles.textStyle}>
                {carOffers.price ? `${carOffers.price} RSD` : "N/A"}
            </TableCell>
            <TableCell sx={styles.textStyle}>
                {carOffers.guarantee ? `${carOffers.guarantee}` : "/"}
            </TableCell>
            <TableCell
                sx={{
                    ...defaultTextStyle,
                    color: hoursLeft < 5 ? "red" : "black",
                }}
            >
                {expiresInText}
            </TableCell>
            <TableCell>
                <ArrowNextTableIcon />
            </TableCell>
        </TableRow>
    );
};

export default AllOffersTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4,
        overflow: "hidden",
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4,
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)",
    },
    getStateBadgeStyle: (stateLabel) => ({
        padding: "4px 12px",
        borderRadius: "999px",
        backgroundColor: stateLabel === "Odbijena" ? "red" : "green",
        color: "white",
        fontWeight: 400,
        fontSize: "12px",
        whiteSpace: "nowrap",
    }),
};
